import {
  useMutation,
  useQueryClient,
  UseMutateFunction,
} from "@tanstack/react-query";

import { VenuePagesRow } from "@punchup/venues/data/venue_pages";
import axios, { AxiosResponse } from "axios";
import { toast } from "@punchup/ui-common/shadcn/ui/use-toast";
import { useTixologi } from "@punchup/data/legacy/hooks";
import { tixologiUrl } from "../../api-base";
import { BOX_OFFICE_FEE_QUERY_KEY } from "./useBoxOfficeFee";

type UseDeleteBoxOfficeFeeReturn = {
  mutate: UseMutateFunction<AxiosResponse, Error, void, unknown>;
  isPending: boolean;
  isSuccess: boolean;
  error: Error | null;
};

export function useDeleteBoxOfficeFee({
  venuePage,
}: {
  venuePage: VenuePagesRow;
}): UseDeleteBoxOfficeFeeReturn {
  const { tixologiData } = useTixologi({
    id: venuePage.id,
    isComedian: false,
  });
  const queryClient = useQueryClient();

  const { mutate, isPending, isSuccess, error } = useMutation({
    mutationFn: async (): Promise<AxiosResponse> => {
      return axios.delete(tixologiUrl("/partners/box-office-fee"), {
        headers: { Authorization: `Bearer ${tixologiData?.token}` },
      });
    },
    onSuccess: () => {
      toast({ title: "Box office fee removed", variant: "success" });
      queryClient.invalidateQueries({
        queryKey: [BOX_OFFICE_FEE_QUERY_KEY, venuePage.id],
        refetchType: "active",
      });
    },
    onError: (error) => {
      toast({
        title: "Error removing the box office fee",
        description: error.message || "Something went wrong",
        variant: "destructive",
      });
    },
  });

  return { mutate, isPending, isSuccess, error };
}
